import { useMemo } from "react";
import { List, ListItem, ListItemText, IconButton } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import useLocalStorage from "../../hooks/useLocalStorage";

export const MemberCertificateList = ({ trainings, memberId }) => {
  const [storageOrganization] = useLocalStorage("organization", null);
  const organization = useMemo(
    () => JSON.parse(storageOrganization),
    [storageOrganization]
  );

  const handleDownload = (tallerId) => {
    const url = `${organization.certificateUrl}/${tallerId}-${memberId}`;

    window.open(url, "download");
  };

  return (
    <>
      <h4>Certificados</h4>
      <List sx={{ width: "100%", maxWidth: 480, bgcolor: "background.paper" }}>
        {trainings.map((t, idx) => {
          return (
            <ListItem
              secondaryAction={
                <IconButton
                  onClick={() => handleDownload(t.tallerId)}
                  aria-label="download"
                >
                  <DownloadIcon />
                </IconButton>
              }
            >
              <ListItemText
                id={`${t.tallerId}-${idx}`}
                primary={t.training.name}
              />
            </ListItem>
          );
        })}
      </List>
    </>
  );
};
